// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import your translation files
import enTranslation from './locales/en/translation.json';
import heTranslation from './locales/he/translation.json';

i18n
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: enTranslation,
      },
      he: {
        translation: heTranslation,
      },
    },
    lng: 'en', // Default language
    fallbackLng: 'he',
    interpolation: {
      escapeValue: false, // React already protects from XSS
    },
  });

export default i18n;
